'use strict'

const _ = require('lodash')

module.exports = {
    INPUT_FOCUS_BEHAVIORS: {
        focus: {methodName: 'requestFocus'},
        blur: {methodName: 'requestBlur'}
    },
    requestFocus() {
        this.shouldApplyFocus = true
    },
    requestBlur() {
        this.shouldApplyBlur = true
    },
    componentDidUpdate() {
        if (this.shouldApplyFocus) {
            if (_.isFunction(this.focus)) {
                this.focus()
            }
            this.shouldApplyFocus = false
        }

        if (this.shouldApplyBlur) {
            if (_.isFunction(this.blur)) {
                this.blur()
            }

            this.shouldApplyBlur = false
        }
    }
}
